import { infer as Infer, z } from 'zod';

export const chatEditSchema = z.object({
  id: z.number(),
  name: z.string().min(1, 'Nazwa jest wymagana').trim(),
  addUserIdArr: z.array(z.number()).optional(),
  removeUserIdArr: z.array(z.number()).optional(),
  addGroupIdArr: z.array(z.number()).optional(),
  removeGroupIdArr: z.array(z.number()).optional(),
});

export type ChatEditSchema = Infer<typeof chatEditSchema>;
